import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/atoms/basic-headline';
import 'ShopUiBundle/components/atoms/btn';
import 'ShopUiBundle/components/atoms/icon';
import 'ShopUiBundle/components/atoms/text-link';
import 'ShopUiBundle/components/molecules/button-dropdown/button-dropdown';
import 'SprykerCatalogBundle/components/molecules/catalog-filter-dropdown';
import 'SprykerCatalogBundle/components/molecules/catalog-filter-single';
import 'SprykerProductBundle/components/atoms/product-tile-flag';
import 'SprykerProductBundle/components/molecules/bike-detail-availability';
import 'SprykerProductBundle/components/molecules/detail-leasing-modal';
import 'SprykerProductBundle/components/molecules/detail-price';
import 'SprykerProductBundle/components/molecules/product-detail-slider';
import 'SprykerProductBundle/components/molecules/variant-colors';
import 'SprykerProductBundle/components/organisms/product-payments-special';
import './style.scss';

// tslint:disable-next-line
register('product-stage', () => import(/* webpackMode: "lazy" */'./product-stage'));
